import moment from "moment";
import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import Datetime from "react-datetime";
import FontAwesome from "react-fontawesome";

import styles from "./SchedulerNavbar.css";

const getDateDisplay = (date, mode) => {
  switch (mode) {
    case "week":
      return `${moment(date).startOf("week").format("MMM DD")} - ${moment(date)
        .endOf("week")
        .format("MMM DD")}`;
    case "month":
      return moment(date).format("MMM YYYY");
    default:
      return moment(date).format("dddd MMM DD, YYYY");
  }
};

const getMomentUnitFromMode = (mode) => {
  switch (mode) {
    case "dispatch":
      return "day";
    default:
      return mode;
  }
};

const DateNavigator = ({ date, mode, onNavigate }) => (
  <span className={styles.dateNavigator}>
    <FontAwesome
      name="chevron-left"
      onClick={() =>
        onNavigate(moment(date).subtract(1, getMomentUnitFromMode(mode)), mode)
      }
    />{" "}
    <OverlayTrigger
      overlay={
        <Popover id="dateNavigatorPopover">
          <Datetime
            input={false}
            onChange={(d) => onNavigate(d, mode)}
            timeFormat={false}
            value={moment(date)}
          />
          <div className="text-center">
            <Button
              bsSize="sm"
              bsStyle="primary"
              onClick={(d) => onNavigate(moment(), getMomentUnitFromMode(mode))}
            >
              <FontAwesome name="bullseye" /> Today
            </Button>
          </div>
        </Popover>
      }
      placement="bottom"
      rootClose
      trigger="click"
    >
      <span>{getDateDisplay(date, mode)}</span>
    </OverlayTrigger>{" "}
    <FontAwesome
      name="chevron-right"
      onClick={() =>
        onNavigate(moment(date).add(1, getMomentUnitFromMode(mode)), mode)
      }
    />
  </span>
);

export default DateNavigator;
